import React from 'react';
import { Modal, Box, IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { CometChatHome } from '../CometChat/components/CometChatHome/CometChatHome';
import { borderRadius } from '@mui/system';
import { Tooltip, Dialog } from "@mui/material";
import PaymentModel from './Container/Chat/PaymentModel';
import Slide from '@mui/material/Slide';

const style = {
  position: 'absolute',
  // top: '50%',
  bottom: '0',
  right : "0",
  // left: '55%',
  // transform: 'translate(-50%, -50%)',
  width: '94%',
  height: '91.5%',
  outline: 'none',
  padding: '20px 40px 20px 20px',
  borderRadius: '24px 0px 0px 24px',
  background: 'rgba(0, 0, 41, 0.96)',
}; 

const ChatModal = ({ open, handleClose }) => {
  return (
    <>
      <Modal open={open}
        onClose={handleClose}
        keepMounted 
        BackdropProps={{
          sx: {
            backgroundColor: 'rgba(0, 0, 0, 0.3)',
            backdropFilter: 'blur(4px)',
          },
        }}
      >
        <Slide direction="left" in={open} mountOnEnter unmountOnExit>
          <Box sx={style}>
            <CometChatHome />
          </Box>
        </Slide>
      </Modal>
      <PaymentModel/>
    </>
  );
};

export default ChatModal;
